import { Box } from '@mui/material'
import { PropsWithChildren } from 'react'

import { Cell } from '@/core/architecture'

type TabPanelProps = PropsWithChildren<{
  index: number
  value: number | string
}>

export const TabPanel: Cell<TabPanelProps> = ({ children, value, index }) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`utoniq-tab-${index}`}
  >
    {value === index && children}
  </Box>
)
